import { render } from "./Justificatif.vue?vue&type=template&id=bb5fdf7a"
import script from "./Justificatif.vue?vue&type=script&lang=js"
export * from "./Justificatif.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__